import React from 'react'

function ViewMoreIcon() {
  return (
    <svg
    className="m-auto w-[4px]"
    viewBox="0 0 4 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="1.83391"
      cy="2.38902"
      rx="1.83"
      ry="1.82988"
      fill="#8C87A6"
    />
    <ellipse
      cx="1.83391"
      cy="7.30914"
      rx="1.83"
      ry="1.82988"
      fill="#8C87A6"
    />
    <ellipse
      cx="1.83391"
      cy="12.2293"
      rx="1.83"
      ry="1.82988"
      fill="#8C87A6"
    />
  </svg>
  )
}

export default ViewMoreIcon